module.exports = __webpack_public_path__ + "img/113.b88a772a.gif";